import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';

import { License }    from '../../pages/license/license';
import { Api } from '../../providers/api/api';
import { Utils } from '../../providers/utils/utils';

/*
*
*  Licenses Page
*
*/
@Component({
  selector: 'licenses',
  templateUrl: 'licenses.html'
})
export class Licenses {

    public licenses : any = [];

    constructor(
        private navCtrl: NavController, 
        public utils: Utils,
        private api : Api
    ) {
        this.init();
    }

    init() {

        this.utils.load();
        this.api.getCached('/license').subscribe((response:any)=>{
            this.licenses = response.result;
            this.utils.unload();
        },(err) => {
            this.utils.unload();
            this.utils.error(this.api.reject(err));
        });

    }

    viewLicense(item) {
        this.navCtrl.push(License, item);
    }

}



// WEBPACK FOOTER //
// ./src/pages/licenses/licenses.ts